import { render, staticRenderFns } from "./alberta_industry.vue?vue&type=template&id=71134a3c&"
import script from "./alberta_industry.vue?vue&type=script&lang=js&"
export * from "./alberta_industry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports